function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { z } from 'zod';
export var CustomerNoteResponse = z.object({
  type: z.literal('application_customer_note'),
  id: z.string(),
  attributes: z.object({}).passthrough()
});
export var AdminNoteResponse = CustomerNoteResponse.extend({
  type: z.literal('application_admin_note')
});
export var ApplicationNotesUserResponse = z.object({
  type: z.literal('note_user'),
  id: z.string(),
  attributes: z.object({}).passthrough()
});
export var NoteAvailableAction = /*#__PURE__*/function (NoteAvailableAction) {
  NoteAvailableAction["READ"] = "read";
  NoteAvailableAction["RESOLVE"] = "resolve";
  NoteAvailableAction["DELETE"] = "delete";
  return NoteAvailableAction;
}({});
var AvailableActions = z.unknown().array().transform(function (actions) {
  return actions.filter(function (action) {
    return _typeof(action) === 'object' && action && 'id' in action && z.nativeEnum(NoteAvailableAction).safeParse(action.id).success;
  });
}).pipe(z.array(z.discriminatedUnion('id', [z.object({
  id: z["enum"]([NoteAvailableAction.READ, NoteAvailableAction.RESOLVE, NoteAvailableAction.DELETE])
})]))).nullish();
export var Note = z.object({
  acceptedByApplicant: z["boolean"]().nullish(),
  acceptedByAutomation: z["boolean"]().nullish(),
  attachments: z.array(z.object({
    id: z.string(),
    fileDownloadLink: z.string(),
    fileName: z.string()
  })).optional()["default"]([]),
  availableActions: AvailableActions,
  content: z.string().nullish(),
  contentEncoding: z["enum"](['markdown', 'html']),
  createdAt: z.string(),
  creatorPersona: z["enum"](['applicant', 'applyboard_support_team', 'applyboard_automation']),
  flags: z.object({
    emailNotification: z["boolean"]().nullish(),
    resolved: z["boolean"]().nullish(),
    restricted: z["boolean"]().nullish()
  }),
  id: z.string(),
  legacyId: z.number()["int"](),
  legacyCreatorId: z.string(),
  parentNoteId: z.string().nullish(),
  readConfirmation: z.object({
    readAt: z.string(),
    readByLegacyId: z.string()
  }).nullish(),
  subject: z.string().nullish(),
  type: z["enum"](['application_customer_note', 'application_admin_note'])
});